@if (!(approvalsService.loading$ | async)) {
  <div mat-dialog-title>
    <div class="wrapper">
      <div>
        <h2>
          @if ((approvalsService.consentRequest$ | async)?.project) {
            <contact-link
              color="white"
              [textDecoration]="false"
          [subject]="
            $safeNavigationMigration((approvalsService.consentRequest$ | async)?.project)
          "></contact-link>
          }
        </h2>
        <h3>
          @if (retrieveSponsors()) {
            <contact-link
              color="white"
              [textDecoration]="false"
          [subject]="
            retrieveSponsors()
          "></contact-link>
          }
        </h3>
      </div>
      <div>
        <button mat-icon-button (click)="this.dialogRef.close()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </div>
}
@if (!(approvalsService.loading$ | async)) {
  <div mat-dialog-content>
    <div>
      <span class="request-type label"
        >{{
        (approvalsService.consentRequest$ | async)?.consentRequestType
        ?.request_type ?? ""
        }}:</span
        ><span class="request-status">{{
        (approvalsService.consentRequest$ | async)?.consentStatus?.status ??
        "\u2014"
      }}</span>
    </div>
    <div>
      <span class="requested label">Requested:</span
        ><span class="received-date">{{
        ($safeNavigationMigration((approvalsService.consentRequest$ | async)?.received_date)
        | date: "MM/dd/yyyy") ?? "\u2014"
      }}</span>
    </div>
    <div>
      <p class="details">
        {{ (approvalsService.consentRequest$ | async)?.details }}
      </p>
    </div>
    <div class="urgency-wrapper">
      <span
        class="is-urgent"
      [class.urgent]="
        (approvalsService.consentRequest$ | async)?.is_urgent_flag
      ">
        <mat-icon inline>{{
          (approvalsService.consentRequest$ | async)?.is_urgent_flag
          ? "flag"
          : "outlined_flag"
        }}</mat-icon>
      </span>
      <span class="due label">Due:</span>
      <span class="timing-date">{{
        ($safeNavigationMigration((approvalsService.consentRequest$ | async)?.timing_date)
        | date: "MM/dd/yyyy") ?? "\u2014"
      }}</span>
    </div>
    <div>
      <p class="urgency-note">
        {{ (approvalsService.consentRequest$ | async)?.urgency_note }}
      </p>
    </div>
    <div class="table-label">
      <h3>Approvals</h3>
      @if (approvalsService.permission$ | async | permission: '_edit') {
        <button
          mat-icon-button
          (click)="saveApprovals()"
          >
          <mat-icon>save</mat-icon>
        </button>
      }
    </div>
    <approvals-table
      [(approvalItems)]="approvalItems"
      [readOnly]="false"
      [approvalsLoading]="!!(approvalsService.approvalsLoading$ | async)"
    [approvalStatuses]="
      (approvalsService.consentApprovalStatuses$ | async) ?? []
    "
      [statuses]="(approvalsService.consentRequiredStatuses$ | async) ?? []"
    [permission]="approvalsService.permission$ | async"></approvals-table>
  </div>
}
@if (!!(approvalsService.loading$ | async)) {
  <div
    mat-dialog-content
    class="loading-content">
    <mat-spinner></mat-spinner>
  </div>
}
